module.exports = __webpack_public_path__ + "media/summer_tipping_tier_4-db25a4f6b799f4320d7cc0e0c18e7617.mp3";